module.exports = __webpack_public_path__ + "img/download.3d9be5bb.png";